import { render, staticRenderFns } from "./ErrorSnackBar.vue?vue&type=template&id=befc3908&scoped=true&"
import script from "./ErrorSnackBar.vue?vue&type=script&lang=js&"
export * from "./ErrorSnackBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befc3908",
  null
  
)

export default component.exports